import Vue from 'vue'
import Component from 'vue-class-component'
import OSS from 'ali-oss'
import dayjs from 'dayjs'
import { fetchOssToken } from '@/api/upload'

import Cropper from './components/Cropper.vue'

const Buckets = {
  image: 'jieyao-pic',
}

@Component({
  name: 'FileUploader',
  template: require('./template.tpl'),
  style: require('./upload.scss'),
  components: { Cropper },
  props: {
    id: {
      type: String,
      default: '',
    },
    letter:{
      type: String,
      default: '',
    },
    intro: {
      type: String,
      default: '',
    },
    // 图片路径
    url: {
      type: String,
      default: '',
    },
    // 图片大小限制
    size: {
      type: Number,
      default: 0,
    },
    // 是否显示图片尺寸
    status: {
      type: Boolean,
      default: false,
    },
    w: {
      type: Number,
      default: 0,
    },
    h: {
      type: Number,
      default: 0,
    },
    mediaType: {
      type: String,
      default: 'image',
    },audio: {
        type: Object,
        default: () => ({}),
      },
      video: {
        type: Object,
        default: () => ({}),
      },
      className: {
        type: String,
        default: '',
      },
      clip: {
        type: Boolean,
        default: true,
      },
      cardShow: {
        type: Boolean,
        default: false,
      }
    },
  })
  
  export default class App extends Vue {
    // initial data
    file = {}
    cropperModel = false
    baseWidth = 104
    action ='https://piccdn.weijieyao.com/' // 上传的地址
    actionUrl = ''
    dialogVisible = false // 是否显示弹框
    percentage = 0 // 上传进度
    fileType = ['jpg', 'png', 'jpeg']
    isSize = false
    audioType = ['mp3', 'aac', 'm4a', 'wav']
    showProgress = false
    playerOptions = {}
    videoType = ['mp4', 'webm', '3gp']
    fileName = ''
    fixedNumber = [this.w, this.h]
    dialogImageUrl = ''
    // computed
    get fileList() {
        return [{
        name: this.id,
        url: this.url,
        }]
    }
    get imageUrl() {
        return this.url
    }

    // 使用自定义方式上传
    async uploadAli(option) {
        this.showProgress = true
        const file = option.file
        await this.uploadFile(file)
    }

    async uploadFile(file) {

      try {
        this.percentage = 0
        const { data } = await fetchOssToken()
        console.log(data)
        const client = new OSS({
          region: 'oss-cn-beijing',
          secure: true,
          accessKeyId: data.up_token.AccessKeyId,
          accessKeySecret: data.up_token.AccessKeySecret,
          stsToken: data.up_token.SecurityToken,
          bucket: 'jieyao-pic',
      })
      return this.handelUpload(client, file)
    } catch (error) {
      this.$message.error('上传失败')
    }
  }

  handelUpload(client, file) {
    const uploadName = getUploadName(this.mediaType === 'image' ? this.file : file)
    const isOk = this.handleBeforeUpload(file)
    if (!isOk) {
      this.showProgress = false
      this.$emit('update:url', this.url)
      return
    }
    client
      .multipartUpload(`web${process.env.VUE_APP_RELATIVE_PATH}/${uploadName}`, file, {
        progress: p => {
          // 上传进度
          this.percentage = parseInt(
            (((p * 10000) / 10000) * 100).toFixed(2)
          )
        },
      })
      .then(results => {
        this.cropperModel = false
        return this.updateData(results, file, client)
      })
      .catch(err => {
        console.log(err)
      })
    }

    updateData(results, file, client) {
      let url = null
      if (this.mediaType === 'image') {
        url = `https://piccdn.weijieyao.com/${results.name}`
        this.$emit('update:url', url)
      } else if (this.mediaType === 'audio') {
        url = `https://audiocdn.weijieyao.com/${results.name}`
        this.$emit('update:audio', { mp3_play_url: url, mp3_duration: this.$refs['audioPlayer'].player.duration, mp3_size: file.size })
        if (this.$refs['audioPlayer'].player.ready) {
          const audio = document.getElementById('audio')
          const audioLoaded = () => {
            const duration = audio.duration
            this.$emit('update:audio', { mp3_play_url: url, mp3_duration: duration, mp3_size: file.size })
            this.showProgress = false
            audio.removeEventListener('loadedmetadata', audioLoaded)
          }
          audio.addEventListener('loadedmetadata', audioLoaded)
        }
      } else {
        // 视频防盗链要签名!
        const signature = client.signatureUrl(results.name, {
          // [expires] {Number} after expires seconds, the url will become invalid, default is 1800
          expires: 31536000000000,
        })
        const a = document.createElement('a')
        a.href = signature
        url = `https://videocdn.weijieyao.com${a.pathname}${a.search}`
  
        const player = this.$refs['videoPlayer'].player
        this.$emit('update:video', { url, duration: player.duration, size: file.size })
        const video = document.getElementById('video')
        const videoLoaded = () => {
          const duration = video.duration
          this.$emit('update:video', { url, duration, size: file.size, fileName: this.fileName })
          this.showProgress = false
          video.removeEventListener('loadedmetadata', videoLoaded)
        }
        video.addEventListener('loadedmetadata', videoLoaded)
      }
    }
    // 上传之前文件校验
    handleBeforeUpload(file) {
      if (this.mediaType === 'image') return true
      const type = file.name
        .split('.')
        .pop()
        .toLowerCase()
  
      if (this.mediaType === 'audio') {
        const isAudio = this.audioType.indexOf(type) !== -1
        if (!isAudio) {
          this.$message.error('文件格式错误')
        }
        return isAudio
      } else {
        this.fileName = file.name
        const isVideo = this.videoType.indexOf(type) !== -1
        if (!isVideo) {
          this.$message.error('文件格式错误')
        }
        return isVideo
      }
    }
    // 上传成功
    handleSuccess(response, file, fileList) {
      // 第二次上传覆盖第一次上传
      if (fileList.length > 1) {
        this.fileList[0] = fileList.shift()
      }
    }
    // 上传进度
    handleProgress(event, file, fileList) {
      this.percentage = file.percentage.toFixed(0)
    }
     // 删除图片
  handleRemove(file, fileList) {
    if (this.mediaType === 'image') {
      this.$emit('update:url', '')
    }
  }

  handleCrop(file, files) {
    if (file.size >= this.size * 1048576) return this.$message.error('图片大于' + this.size + 'M')
    this.file = file
    if (!this.clip) {
      return this.uploadFile(file.raw)
    }
    this.cropperModel = true
  }

  updated() {
    if (this.$refs.vueCropper) {
      this.$refs.vueCropper.Update()
    }
  }
  handlePreviewSingle() {
    this.dialogVisible = true
  }

  mouseEnter() {
    this.$refs.reUpload.style.display = 'flex'
  }
  mouseLeave() {
    this.$refs.reUpload.style.display = 'none'
  }
}

function getUploadName(file) {
  const d = new Date()
  return `${dayjs(d).format('YYYYMMDD')}${Date.now()}.${file.name.split('.').pop()}`
}


// WEBPACK FOOTER //
// ./src/components/common/upload/index.js